import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

import Oauth from '../../utils/Oauth.js';
import SessionConstants from '../../config/SessionConstants.js';
import Loading from '../Loading';
import APIUtils from '../../utils/APIUtils.js';

export default class OAuthCallback extends Component {
    state = {
        loading: true,
        hasToken: false,
    };

    async componentDidMount() {
        //  search for the code querystring item. If it's there, we know this came from SAMS. Do a SAMS login
        //  if we find a devlogin flag, then do a local dev login
        //  if we find neither, not sure how we got here. Get outta here!
        const code = (location.search.match(/code=([^&]+)/) || [])[1];
        // console.log("SAMS code = " + code);

        let hasToken = false;

        try {
            if (code !== undefined) {
                await Oauth.getSamsTokens(code);
                if (sessionStorage.getItem(SessionConstants.SAMS_ACCESS_TOKEN) !== null) {
                    await Oauth.getUserInfoUsingSams();
                    if (sessionStorage.getItem(SessionConstants.PROGRAM_ID) !== null) {
                        hasToken = true;
                        sessionStorage.setItem(SessionConstants.LOGOUT_STATUS, false);
                    }
                } else {
                    sessionStorage.setItem(SessionConstants.ERROR_MESSAGE, 'Could not login to ED3N using SAMS');
                }
            } else if (sessionStorage.getItem(SessionConstants.DEVLOGIN) === 'true') {
                console.log("Dev Login USR = " + sessionStorage.getItem(SessionConstants.DEVLOGIN_USERNAME));
                console.log("Dev Login PWD = " + sessionStorage.getItem(SessionConstants.DEVLOGIN_PASSWORD));
                
                try {
                    const loginResponse = await APIUtils.verifyLogin();
                    if (loginResponse === 'OK') {
                        await Oauth.getUserInfoUsingDev();
                        if (sessionStorage.getItem(SessionConstants.PROGRAM_ID) !== null) {
                            hasToken = true;
                            sessionStorage.setItem(SessionConstants.LOGOUT_STATUS, false);
                        }
                    } else {
                        throw new Error("Invalid credentials"); // force the error catch
                    }
                } catch (error) {
                    console.error("Login error:", error);
                    sessionStorage.setItem(SessionConstants.DEVLOGIN, 'false');
                    sessionStorage.setItem(SessionConstants.ERROR_MESSAGE, 'Dev login credentials are invalid');
                }
            } else {
                sessionStorage.setItem(SessionConstants.ERROR_MESSAGE, 'No SAMS or DEV login detected');
            }
        } catch (error) {
            console.error("Unexpected error:", error);
            sessionStorage.setItem(SessionConstants.ERROR_MESSAGE, 'An unexpected error occurred during login');
        }

        this.setState({
            loading: false,
            hasToken,
        });
    }

    render() {
        return (
            <div>
                <Loading isLoading={this.state.loading} />
                {this.state.loading
                    ? 'Processing login...'
                    : (this.state.hasToken
                        ? <Navigate to="/home" replace />
                        : <Navigate to="/error" replace />
                    )
                }
            </div>
        );
    }
}
